module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"sub_title":"買い物かごの商品の表示"}}')
  delete Component.options._Ctor
}
